import { ethers } from 'ethers'
import { ChainId } from '@nominex/nomiswap-sdk'
import { getMulticallContract } from 'utils/contractHelpers'

export interface Call {
  address: string // Address of the contract
  name: string // Function name on the contract (example: balanceOf)
  params?: any[] // Function params
}

const multicall = async <T = any>(abi: any[], calls: Call[], chainId = ChainId.BSC): Promise<T> => {
  try {
    const multi = getMulticallContract(chainId)
    const itf = new ethers.utils.Interface(abi)

    const calldata = calls.map((call) => ({
      target: call.address.toLowerCase(),
      callData: itf.encodeFunctionData(call.name, call.params),
    }))
    const { returnData } = await multi.aggregate(calldata)

    return returnData.map((call, i) => itf.decodeFunctionResult(calls[i].name, call)) as T
  } catch (error: any) {
    throw new Error(error)
  }
}

export default multicall
